import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { BadgeType } from '@mylighthouse/prism-ember/types/components/prism/badge';

interface HotelPricingAssistantTableCellsTdWithBadgeSignature {
  Args: {
    cellData: {
      badgeLabel?: string;
      badgeType?: BadgeType;
      formattedValue: string;
    };
  };
}

const HotelPricingAssistantTableCellsTdWithBadge = <template>
  <span class="flex flex-row items-center gap-200">
    <span class="truncate">
      {{@cellData.formattedValue}}
    </span>

    {{#if @cellData.badgeLabel}}
      <span class="text-nowrap">
        <PrismBadge
          @label={{@cellData.badgeLabel}}
          @type={{@cellData.badgeType}}
        />
      </span>
    {{/if}}
  </span>
</template> satisfies TOC<HotelPricingAssistantTableCellsTdWithBadgeSignature>;

export default HotelPricingAssistantTableCellsTdWithBadge;
